export default "__VITE_ASSET__DzOiSnRM__"